import { AxiosError } from 'axios';

import { ImeasurementPointResult, IopenRepairConflict } from '../models';

export interface IopenRepairConflictPayload {
    conflicts: IopenRepairConflict[];
    blockedResults: ImeasurementPointResult[];
    savedCount: number;
}

const ADD_RESULTS_PATH = 'AddJobMeasurementPointListResultsList';

/**
 * MMG-4336: the API answers a blocked inspection save with 409 and a partial accept - the clean
 * items in the batch are already stored, only the assets carrying an open repair were rejected.
 */
export const isOpenRepairConflict = (err: AxiosError | undefined, url: string): boolean =>
    err?.response?.status === 409 && url.includes(ADD_RESULTS_PATH);

/**
 * Narrows a 409 body to the rejected answers so they can be kept locally and retried with the
 * override. Returns null when the response carries no conflicts, meaning the 409 came from
 * something else and belongs to the generic error path.
 */
export const buildOpenRepairConflictPayload = (
    responseData: unknown,
    batch: ImeasurementPointResult[]
): IopenRepairConflictPayload | null => {
    const data = responseData as { savedCount?: number; conflicts?: IopenRepairConflict[] } | undefined;
    const conflicts = data?.conflicts || [];

    if (!conflicts.length) {
        return null;
    }

    const blockedIDs = new Set(conflicts.map(conflict => conflict.installBaseID));

    return {
        conflicts,
        blockedResults: batch.filter(result => blockedIDs.has(result.installBaseID)),
        savedCount: data?.savedCount || 0
    };
};
